import { OnInit, Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoDemand } from 'app/shared/models/legal/demand/dto-demand.model';
import { MatRadioChange } from '@angular/material';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoLiquidation } from 'app/shared/models/legal/dto-liquidation.model';
import { DemandService } from 'app/views/appviews/demand.service';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DatePipe } from '@angular/common';
import { DocumentService } from 'app/shared/services/document.service';
import { LiquidationDetailComponent } from '../../../liquidation/liquidation-detail/liquidation-detail.component';
import { IDtoAllegation } from 'app/shared/models/legal/demand/dto-allegation.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalRestartDemandComponet } from 'app/views/modales/demand/restart-demand/modal-restart-demand.component';

@Component({
    selector: '[allegation]',
    templateUrl: './allegation.template.html',
    styleUrls: ['./allegation.style.scss']
})
export class AllegationComponent implements OnInit, OnChanges {
    private modalRef: BsModalRef;
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    /**Formularios */
    private formDemand: FormGroup;
    /**Notificaciones */
    private configToast: any;
    /**Inputs */
    @Input() private employeeDemand: IDtoEmployee;
    @Input() private demand: IDtoDemand;
    @Input() private requisition: IDtoRequisition;
    private actionLiquidation: string;
    @Output() getRequisitionId = new EventEmitter<number>();
    @Output() routeName = new EventEmitter<string>();
    private module = 'Alegato';
    private locale: string = 'es';
    /**Securty */
    private fileNameVoucherAllegation: string;
    private fileVoucherAllegation: File;
    private fileNameVoucherDemandClosing: string;
    private fileVoucherDemandClosing: File;
    @ViewChild(LiquidationDetailComponent, { static: false }) liquidationDetailComponent;
    step = 7;
    lockSaved: boolean;
    @Output() dataSaved = new EventEmitter<{step: number, isCompleted: boolean, savedData?: any}>();
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private demandService: DemandService
        , private documentService: DocumentService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private identityService: IdentityService
        , private datePipe: DatePipe
        , private modalService: BsModalService) {
        this.initializeformDemand();
        this.configToast = configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.demandService.currentStepChallenge$.subscribe((res) => {
            let diff = res - this.step;
            if (diff > 0) {
               this.lockSaved = true;
            } else {
                this.lockSaved = false;
            }
        });
        this.demandService.concludeDemandChallenge$.subscribe((res) => {
            if (res) {
                this.formDemand.disable();
            } else {
                this.formDemand.enable();
            }
        });
        if(this.demand.concludeDemand) {
            this.formDemand.disable();
        }
        this.demandService.documentNumberChallenge$.subscribe((res) => {
            this.formDemand.get('fileNumber').setValue(res);
        });
        this.lockSaved = this.demandService.generateLockSaved(this.demand.step, this.step);
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.demand !== undefined) {
            if (changes.demand.currentValue !== undefined) {
                if (changes.demand.currentValue.receptionDemand) {
                    this.formDemand.get('fileNumber').setValue(changes.demand.currentValue.receptionDemand.fileNumber);
                }
                if (changes.demand.currentValue.allegation) {
                    this.patchData();
                }
            }
        }
    }
    private onFileSelectedVoucherAllegation(event) {

        this.fileVoucherAllegation = event.target.files[0];

        if (this.fileVoucherAllegation) {

            this.fileNameVoucherAllegation = this.fileVoucherAllegation.name;
        }
    }
    private onFileChange(event) {
        event.value = '';
    }
    private onFileSelectedVoucherDemandClosing(event) {

        this.fileVoucherDemandClosing = event.target.files[0];

        if (this.fileVoucherDemandClosing) {

            this.fileNameVoucherDemandClosing = this.fileVoucherDemandClosing.name;
        }
    }
    private radioChange($event: MatRadioChange) {
        switch ($event.source.name) {
            case 'concludeDemand':
                this.makeRequiredFields($event.value);
                break;
        }
    }
    private makeRequiredFields(value: boolean): void {
        if (value) {
            this.formDemand.get('dateTimeClosing').setValidators([Validators.required]);
            this.formDemand.get('voucherClosing').setValidators([Validators.required]);
            this.formDemand.get('commentClosing').setValidators([Validators.required, Validators.maxLength(2000)]);
        } else {
            this.formDemand.get('dateTimeClosing').setValidators(null);
            this.formDemand.get('voucherClosing').setValidators(null);
            this.formDemand.get('commentClosing').setValidators(null);
        }
        this.formDemand.get('dateTimeClosing').updateValueAndValidity();
        this.formDemand.get('voucherClosing').updateValueAndValidity();
        this.formDemand.get('commentClosing').updateValueAndValidity();
    }

    private initializeformDemand() {
        this.formDemand = this.formBuilder.group({
            fileNumber: [null, [Validators.required]],
            voucherAllegation: [null],
            concludeDemand: [null, [Validators.required]],
            dateTimeClosing: [null],
            commentClosing: [null],
            voucherClosing: [null]
        });
    }
    private submitForm() {
        if (this.formDemand.valid) {

            if (this.demand.allegation != null) {
                this.updateData();
            } else {
                this.saveData();
            }
        } else {
            this.snotifyService.error('Llene todos los datos para poder continuar'
                , 'Error', this.configToast);
            this.configGeneral.touchedControls(this.formDemand);
        }
    }
    private saveData(): void {
        let dto = this.formDemand.value as IDtoAllegation;
        dto.demandId = this.demand.id;
        this.demandService.addAllegation(dto).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.snotifyService.success('Registro guardados correctamente'
                        , 'Éxito', this.configToast);
                        let allegation = x.data as IDtoAllegation;
                        this.demand.allegation = allegation;
                        this.demand.concludeDemand = allegation.concludeDemand;
                        this.demandService.concludeDemand(this.demand.concludeDemand);
                        this.demandService.currentStep(this.step);
                        this.dataSaved.emit({
                            step: this.step, // Número del paso
                            isCompleted: true,
                            savedData: allegation // Los datos guardados
                          });
                        this.uploadFileVoucherallegation(allegation.id, false, this.fileVoucherAllegation);
                        if (this.formDemand.value.concludeDemand) {
                            this.uploadFileVoucherDemandClosing(allegation.id, false, this.fileVoucherDemandClosing);
                        }
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private processStage(liquidation: IDtoLiquidation): void {
        //this.submitForm();
        this.liquidationDetailComponent.updateLiquidation();
    }
    private updateData(): void {
        let dto = this.formDemand.value as IDtoAllegation;
        dto.demandId = this.demand.id;
        dto.id = this.demand.allegation.id;
        dto.status = this.demand.allegation.status;
        dto.creationDate = this.demand.allegation.creationDate;
        this.demandService.updateAllegation(dto).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.demand.concludeDemand = dto.concludeDemand;
                    this.demandService.concludeDemand(this.demand.concludeDemand);
                    this.demandService.currentStep(this.step);
                    this.snotifyService.success('Registros actualizados correctamente'
                        , 'Éxito', this.configToast);
                        if (this.formDemand.value.concludeDemand && this.demand.allegation.documentDemandClosing == null) {
                            this.uploadFileVoucherDemandClosing(dto.id, false, this.fileVoucherDemandClosing);
                        }
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private patchData(): void {
        this.demand.allegation.dateTimeClosing = new Date(this.demand.allegation.dateTimeClosing);
        this.demand.allegation.creationDate = new Date(this.demand.allegation.creationDate);
        this.makeRequiredFields(this.demand.allegation.concludeDemand);
        this.formDemand.patchValue(this.demand.allegation);
        if(this.demand.allegation.documentAllegation) {
            this.fileNameVoucherAllegation = this.demand.allegation.documentAllegation.fileName;
            this.formDemand.get('voucherAllegation').setValidators(null);
            this.formDemand.get('voucherAllegation').updateValueAndValidity();
        }
        if(this.demand.allegation.documentDemandClosing) {
            this.fileNameVoucherDemandClosing = this.demand.allegation.documentDemandClosing.fileName;
            this.formDemand.get('voucherClosing').setValidators(null);
            this.formDemand.get('voucherClosing').updateValueAndValidity();
        }
    }
    private uploadFileVoucherallegation(reference: number, isReplaced: boolean, file: File): void {
        this.spinner.show();
        let document = {} as IDtoDocument;
        const fileName = file.name;
        let sp = fileName.split('.').pop();
        let fileNameNew = `${this.employeeDemand.id}_ComprobanteAlegato_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
        document.fileName = fileNameNew;
        this.fileNameVoucherAllegation = fileNameNew;
        document.referenceId = reference;
        document.folder = this.module;
        document.module = this.module;
        document.name = "ComprobanteAlegato";
        document.acceptDuplicate = false;
        document.isReplaced = isReplaced;
        this.documentService.addDocument(document, file).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
                let document = res.data as IDtoDocument;
                //this.addModuleLog(document.id, 'addDocument', 'documents');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private uploadFileVoucherDemandClosing(reference: number, isReplaced: boolean, file: File): void {
        this.spinner.show();
        let document = {} as IDtoDocument;
        const fileName = file.name;
        let sp = fileName.split('.').pop();
        let fileNameNew = `${this.employeeDemand.id}_ComprobanteCierreDemanda_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
        document.fileName = fileNameNew;
        this.fileNameVoucherDemandClosing = fileNameNew;
        document.referenceId = reference;
        document.folder = this.module;
        document.module = this.module;
        document.name = "ComprobanteAlegatoCierreDemanda";
        document.acceptDuplicate = false;
        document.isReplaced = isReplaced;
        this.documentService.addDocument(document, file).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
                let document = res.data as IDtoDocument;
                //this.addModuleLog(document.id, 'addDocument', 'documents');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private openModalRestartDemand() {
        const initialState = {
            stage: 'Alegatos',
            liquidationId: this.demand.liquidationId
        };
        this.modalRef = this.modalService.show(ModalRestartDemandComponet
            , Object.assign({ initialState }
                , this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                location.reload();
            }
        });
    }
    private addModuleLog(id: number, action: string, table: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = table;
        dto.module = this.module;
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
